import { takeLatest, put } from 'redux-saga/effects';
import AutoCompleteActionTypes from './types';
import api from '../../../../../utils/apiConfig';
import { searchSuccess, searchFailure, unLoadingSearchResultsSuccess } from './actions';
import urls from './urls';
import find from 'lodash/find';
import { mapping, PlacesMapping } from '../data-mapping';
import { ResponseGenerator } from '../../../../../utils/globalContracts';

function* getList(action: { type: string; payload: { url: any; searchText: any } }) {
  let requestUrl = action.payload.url(action.payload.searchText);
  try {
    const response: ResponseGenerator = yield api.get(requestUrl);
    let mappingFunc = find(mapping, { key: action.payload.url.name })?.value;
    let options = mappingFunc ? mappingFunc(response.data) : [];
    if (action.payload.url.name === 'searchSauron') {
      let placesUrl = urls.placesSearch(action.payload.searchText);
      const places: ResponseGenerator = yield api.get(placesUrl);
      options = [...options, ...PlacesMapping(places.data)];
    }
    yield put(searchSuccess(options));
  } catch (e) {
    yield put(searchFailure());
    console.log(e);
  }
}

function* saveSelectedPlace(action: { type: string; payload: any }) {
  let requestUrl = urls.saveSelectedPlace();
  try {
    const response: ResponseGenerator = yield api.post(requestUrl, action.payload);
    console.log(response);
  } catch (e) {
    console.log(e);
  }
}

function* getUnloadingResults(action: any) {
  const requestURL: any = urls.searchUnloadingPoint(action.payload);

  try {
    const response = yield api.get(requestURL);

    // if (!response.data.success) {
    //   yield put(showSnackBar({ variant: 'error', message: 'Error in fetching quote quality.' }));
    // }
    yield put(unLoadingSearchResultsSuccess(response.data));
  } catch (e) {
    // yield put(showSnackBar({ variant: 'error', message: 'Error in fetching quote quality.' }));
    // console.log({ e });/
  }
}

function* autoCompleteSagas() {
  yield takeLatest(AutoCompleteActionTypes.SEARCH_START, getList);
  yield takeLatest(AutoCompleteActionTypes.SAVE_SELECTED_PLACE, saveSelectedPlace);
  yield takeLatest(AutoCompleteActionTypes.UNLOADING_SEARCH_RESULTS_START, getUnloadingResults);
}

export default autoCompleteSagas;
